import React from 'react';

const MobileNotFoundPage = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-amber-50 text-amber-700">
            <h1 className="text-5xl font-bold mb-4">404</h1>
            <p className="text-xl mb-6">앱 페이지를 찾을 수 없습니다</p>
            <a
                href="/app"
                className="px-6 py-2 bg-amber-500 text-white rounded-xl active:bg-amber-600 transition"
            >
                홈으로 돌아가기
            </a>
        </div>
    );
};

export default MobileNotFoundPage;
